<div style="width: 100%; background-color: #aff5d4; border: solid 2px green">
  <div style="padding-top: 10px; padding-left: 10px; padding-bottom: 10px;">
    <div style="margin-bottom: 3px; color: crimson; font-size: 19px;">Login as Test User</div>
    <div>Military ID: 12345</div>
    <div>Password: 1993</div>
  </div>
</div>


